import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useUnreadNotifications() {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const fetchUnread = () =>
      api
        .get("/notifications/unread-count")
        .then((res) => !cancelled && setUnread(res.data.unread))
        .catch(() => {});
    fetchUnread();
    const t = setInterval(fetchUnread, 30000);
    const onChanged = () => fetchUnread();
    const onVisible = () => { if (document.visibilityState === "visible") fetchUnread(); };  // RC52-NOT-002: refresh on return to tab/window
    window.addEventListener("notifications:changed", onChanged);
    window.addEventListener("focus", onVisible);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      clearInterval(t);
      window.removeEventListener("notifications:changed", onChanged);
      window.removeEventListener("focus", onVisible);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return unread;
}
